import { QueryClient } from '@tanstack/react-query';
import { FunnelStatus } from 'src/api/generated';
import {
  updateCache,
  getQueriesSnapshots,
} from 'src/modules/shared/utils/cache/update.util';

/**
 * Updates the funnel status in the cache
 */
export const updateFunnelStatusCache = (
  queryClient: QueryClient,
  optimisticStatus: FunnelStatus
): void => {
  updateCache({
    queryClient,
    queryKey: ['crm/funnels/statuses'],
    updatedData: optimisticStatus,
  });

  updateCache({
    queryClient,
    queryKey: ['crm/funnels/statuses', optimisticStatus.id],
    updatedData: optimisticStatus,
    exact: true,
  });
};

/**
 * Takes a snapshot of the current cache state for funnel statuses
 */
export const getFunnelStatusCacheSnapshot = async (
  queryClient: QueryClient
) => {
  return await getQueriesSnapshots(queryClient, [
    ['crm/funnels/statuses'],
    ['crm/funnels'],
  ]);
};
